module.exports = __webpack_public_path__ + "images/d688392fa1c6b486697cc57c0dff342d-IMG_4272a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/IMG_4272a.jpg
// module id = ./src/assets/images/slides/living/IMG_4272a.jpg
// module chunks = 0